import { Component, Input } from '@angular/core';
import { DetailsXMLSection } from 'src/app/model/section/details-xml-section';

@Component({
  selector: 'app-details-xml-section',
  templateUrl: './details-xml-section.component.html',
  styleUrls: ['./details-xml-section.component.scss']
})
export class DetailsXMLSectionComponent {
  @Input() sections: DetailsXMLSection[] = [];
}
